<template>
  <BaseModal :name="name" width-class="tw-max-w-[550px]">
    <div>
      <div
        class="tw-flex tw-justify-center tw-rounded-t-xl tw-p-3 tw-text-white"
        :class="modalColorClasses.header"
      >
        <span v-if="!$slots.icon" class="tw-h-6 tw-w-6">
          <BinIcon />
        </span>
        <span v-else class="tw-h-6 tw-w-6">
          <slot name="icon" />
        </span>
      </div>
      <div class="tw-p-5 tw-text-center">
        <h2 class="tw-heading-2">{{ header }}</h2>
        <p v-if="description" class="tw-m-1 tw-text-sm tw-text-neutral-600">
          {{ description }}
        </p>
        <div class="tw-mt-5 tw-flex tw-justify-center tw-space-x-2">
          <BaseButton
            color="outline-gray"
            @click="closeModal(name)"
            class="tw-w-40"
          >
            {{ cancelButtonText }}
          </BaseButton>
          <BaseButton
            :color="modalColorClasses.confirmationButton"
            @click="handleClickConfirmationButton"
            class="tw-w-40"
            test_id="modal-delete"
          >
            {{ confirmationButtonText }}
          </BaseButton>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseButton from '../BaseButton.vue'
import BinIcon from '@/assets/images/icons/bin.svg'
import { computed } from 'vue'
import { useModals } from '@/shared/composables/useModals.js'
import BaseModal from '@/shared/components/BaseModal.vue'

const emit = defineEmits(['confirmation'])

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  header: {
    type: String,
    default: 'Are you sure you want to delete this entry?',
  },
  description: {
    type: String,
    default: '',
  },
  cancelButtonText: {
    type: String,
    default: 'No, cancel',
  },
  confirmationButtonText: {
    type: String,
    default: 'Yes, delete',
  },
  color: {
    type: String,
    default: 'red',
  },
})

const { closeModal } = useModals()

const modalColorClasses = computed(() => {
  if (props.color === 'red') {
    return {
      header: 'tw-bg-error-500',
      confirmationButton: 'red',
    }
  } else if (props.color === 'blue') {
    return {
      header: 'tw-bg-primary-500',
      confirmationButton: 'secondary',
    }
  }
  return { header: 'tw-bg-neutral-50', confirmationButton: 'gray' }
})

const handleClickConfirmationButton = () => {
  emit('confirmation')
  closeModal(props.name)
}
</script>
